import React from 'react';

const InteractiveDiv = ({ children, handler, tabIndex, ...props }) => (
  <div
    onClick={handler}
    onKeyUp={handler}
    role="button"
    tabIndex={tabIndex || '0'}
    {...props}
  >
    {children}
  </div>
);

export default InteractiveDiv;
